const stepsMixin = {
  props: {
    step: {
      type: Object,
    },
  },
};

export default stepsMixin;
